'use client';

interface SkillTagProps {
  children: React.ReactNode;
  variant?: 'outline' | 'secondary';
  className?: string;
}

export function SkillTag({ children, variant = 'outline', className = '' }: SkillTagProps) {
  const variants = {
    outline: 'border-border text-muted-foreground',
    secondary: 'bg-secondary-background text-primary',
  };

  return (
    <span
      className={`inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-medium transition-colors ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  );
}

